import axios from 'axios';
import { Message } from 'element-ui';
import { otherModule } from '@/store/modules/other';
import { appConfigModule } from '@/store/modules/appConfig';
import { A0xfd9bb1 } from '@/utils/sing.js';

const messageErr: string = '网络请求超时...';
const service: any = axios.create({
    baseURL: appConfigModule.appConfig.PCRequestApi
    // withCredentials: true
    // timeout: 5000
});
// 请求拦截器
service.interceptors.request.use((config: any) => {
        const Signature = A0xfd9bb1(appConfigModule.appConfig.shopId);

        // 向每个请求添加X-Access-Token头，您可以在此处添加其他自定义头
        if (appConfigModule.appConfig.shopId) {
            // eslint-disable-next-line dot-notation
            config.headers['Authorization'] = 'Bearer ' + appConfigModule.appConfig.shopId;
            // eslint-disable-next-line dot-notation
            config.headers['Language'] = otherModule.language === 'zh' ? 'zh-cn' : 'zh-tw';
        }

        // 公共签名
        config.headers.DeviceType = Signature.D;
        config.headers.ApplicationVersion = Signature.A;
        config.headers.Timestamp = Signature.T;
        config.headers.Sign = Signature.S;
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use((response: any) => {
        const { Code, Msg } = response.data;
        // 根据自己实际业务判断
        if (Code === 0) {
            return Promise.resolve(response.data);
        }

        // 不出现以上code的情况下
        Message({
            showClose: true,
            message: Msg || messageErr,
            type: 'error',
            duration: 5 * 1000
        });
        return Promise.reject(Msg);
    },
    (error: any) => {
        Message({
            showClose: true,
            message: error,
            type: 'error',
            duration: 5 * 1000
        });
        console.warn(error);
        return Promise.reject(error);
    }
);

export default service;
